import Vue from "vue";
import moment from "moment";

const resourcePost = {
  namespaced: true,
  mutations: {
    SET_ITEMS( state, payload ){
  //    state.items[ payload.id ] = Object.assign({}, state.items[ payload.id ], payload.data );
    },
    UNSET_ITEMS( state, payload ){

    },
    SET_LIST( state, payload ){

    },
    CLEAR_LIST( state, payload ){

    },
  },
  getters: {
    GET_ITEMS_BY_LIST: state => payload => {
      /* payload로 날아온 listName을 이용해서 state.lists를 조회 후, state.lists[ listName ].docs 를 받아오면 댐. */
    }
  },
  actions: {
    getItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/crm/post", { params: { "page": payload.page, "size": payload.size, "post_type": payload.post_type, "search_text": payload.search_text } } ).then( res => {
          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },
    /*createItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post( '', payload.data ).then( res => {
           commit( "SET_ITEM", res.data )
          return resolve( res );
        }).catch( reject );
      });
    },*/
    updateClicks({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/crm/post/${payload._id}`).then( res => {
          return resolve( res );
        })
      })
    },
    deleteItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.delete( /* endpoint */ ).then( res => {
          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },
    updateItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        let params = {
          post_category: payload.category || '',
          post_subject: payload.subject.value,
          post_type: payload.board,
          post_descript: '',
          post_content: payload.post.value,
          post_display_datetime: moment().format('YYYY-MM-DD'),
          document_id: payload.document_id || '',
        };

        if (payload.user) {
          params.customer_id = payload.user._id,
          params.customer_name = payload.user.customer_name
        };

        Vue.axios.post(rootState.config.hostName + "/v1/crm/post/create", params).then( res => {
          //commit( "SET_ITEM", res.data )
          return resolve( res );
        }).catch( reject );
      });
    },
    getItemByDocumentId({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/crm/post.document/${payload.document_id}`, { params: payload })
          .then(resolve)
          .catch(reject);
      });
    },
    updateItem({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise( ( resolve, reject ) => {
        Vue.axios
          .put(`${hostName}/v1/crm/post/edit/${payload.id}`, payload)
          .then(resolve)
          .catch(reject);
      });
    },
    deleteItem({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise( ( resolve, reject ) => {
        Vue.axios
          .delete(`${hostName}/v1/crm/post/${payload.id}`, payload)
          .then(resolve)
          .catch(reject);
      });
    }
  }

};

export default resourcePost;
